import React, { useCallback, useState, useRef } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import join from 'lodash/join'
import map from 'lodash/map'
import toLower from 'lodash/toLower'

import { Chip } from '@material-ui/core'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import ActivityForm from '@galo-monitor/web-containers/forms/property/ActivityForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

import { TitleContainer } from './theme'

const ActivityModal = (props) => {
  const {
    id,
    open,
    handleClose,
    onSuccess,
    activity,
    activityState,
    classes,
    currentHarvest,
    plots
  } = props

  const [loading, setLoading] = useState(false)

  const t = useT()
  const { createDialog } = useDialog()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    err => {
      setLoading(false)
      const { errors, message } = err.response.data
      const errorMessages = map(errors, error => (
        <React.Fragment key={ error.field }>
          {`${ t('error') }: ${ t('minLength validation failed') }.`}
          <br />
          {
            t('validation error message', {
              field: error.field,
              rule: error.rule
            })
          }.
          <br />
        </React.Fragment>
      ))

      createDialog({
        id: 'error-activity',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'female',
            action: toLower(t('register')),
            this: toLower(t('activity', { howMany: 1 }))
          })  }.`,
          message: isEmpty(errorMessages) ? t(message) : errorMessages
        }
      })
    },
    [createDialog, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ (
        <TitleContainer>
          {t(`${ activity.type } activity type`)}
          <Chip
            className={ join([classes.chip, classes.success, classes.fontWhite], ' ') }
            label={ currentHarvest.name }
          />
        </TitleContainer>
      ) }
      maxWidth="lg"
      fullWidth
      FooterComponent={ () => (
        <>
          <Button
            id="import"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <ActivityForm
        ref={ formRef }
        activity={ activity }
        activityState={ activityState }
        currentHarvest={ currentHarvest }
        plots={ plots }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

ActivityModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  activity: PropTypes.shape({
    type: PropTypes.string.isRequired
  }),
  activityState: PropTypes.string,
  classes: PropTypes.object.isRequired,
  currentHarvest: PropTypes.object,
  plots: PropTypes.array
}

ActivityModal.defaultProps = {
  activity: {},
  activityState: 'plans',
  currentHarvest: {},
  plots: []
}

export default ActivityModal
